import * as client_hooks from '../../../src/hooks.client.js';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158')
];

export const server_loads = [0,8,9,13,14,15,17,23,25,29,35,40];

export const dictionary = {
		"/": [41],
		"/admin/booking-update": [43,[2]],
		"/admin/chat": [44,[2]],
		"/admin/compta": [45,[2]],
		"/admin/etat-prelevement": [46,[2]],
		"/admin/factures": [47,[2]],
		"/admin/gestion-relance-groupes": [~48,[2,4]],
		"/admin/gestion-relance-groupes/detail/[rToken]": [~49,[2,4]],
		"/admin/google": [50,[2]],
		"/admin/google/restaurant-fiche": [51,[2]],
		"/admin/groupes": [52,[2,5]],
		"/admin/groupes/[number]": [53,[2,5,6]],
		"/admin/groupes/[number]/chat": [54,[2,5,6]],
		"/admin/groupes/[number]/historique": [55,[2,5,6]],
		"/admin/groupes/[number]/informations": [56,[2,5,6]],
		"/admin/groupes/[number]/menus": [57,[2,5,6]],
		"/admin/groupes/[number]/messages": [58,[2,5,6]],
		"/admin/groupes/[number]/mobile": [59,[2,5,6]],
		"/admin/groupes/[number]/options": [60,[2,5,6]],
		"/admin/groupes/[number]/parametres": [61,[2,5,6]],
		"/admin/groupes/[number]/proforma": [62,[2,5,6]],
		"/admin/no-show-stats": [63,[2]],
		"/admin/parrainage": [64,[2,7]],
		"/admin/parrainage/form": [65,[2,7]],
		"/admin/parrainage/list": [~66,[2,7]],
		"/admin/prelevements": [67,[2]],
		"/admin/[rToken]/import": [42,[2,3]],
		"/ai-generate-text": [~68],
		"/ai-generate-text/[restaurantToken]/content": [69,[8]],
		"/ai-generate-text/[restaurantToken]/text": [70,[8]],
		"/backoffice": [~71,[9]],
		"/backoffice/calendrier": [~72,[9]],
		"/backoffice/dashboard": [73,[9,10]],
		"/backoffice/ma-salle": [74,[9,11]],
		"/backoffice/ma-salle/parametres": [75,[9,11,12]],
		"/backoffice/ma-salle/timeline": [76,[9,11]],
		"/backoffice/mes-actualites": [77,[9,13]],
		"/backoffice/mes-actualites/email": [78,[9,13,14]],
		"/backoffice/mes-actualites/email/[newsToken]": [~79,[9,13,14]],
		"/backoffice/mes-actualites/mon-site/[[token]]": [~80,[9,13]],
		"/backoffice/mes-actualites/sms/[[token]]": [~81,[9,13]],
		"/backoffice/mes-cartes-cadeaux": [82,[9,15]],
		"/backoffice/mes-cartes-cadeaux/ma-carte-cadeau": [83,[9,15]],
		"/backoffice/mes-cartes-cadeaux/mes-acheteurs": [84,[9,15]],
		"/backoffice/mes-commandes": [~85,[9,16]],
		"/backoffice/mes-reservations": [86,[9,17]],
		"/backoffice/mes-reservations/editeur": [87,[9,17]],
		"/backoffice/mes-reservations/ma-salle": [88,[9,17]],
		"/backoffice/mes-reservations/timeline": [89,[9,17]],
		"/backoffice/mon-compte/mes-finances": [90,[9,18]],
		"/backoffice/mon-compte/paiement-en-ligne": [91,[9,19]],
		"/backoffice/mon-gestionnaire-de-groupes": [~92,[9,20]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]": [93,[9,20,21]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]/acompte": [94,[9,20,21]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]/chat": [95,[9,20,21]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]/informations": [96,[9,20,21]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]/menus": [97,[9,20,21]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]/messages": [98,[9,20,21]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]/mobile": [99,[9,20,21]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]/options": [100,[9,20,21]],
		"/backoffice/mon-gestionnaire-de-groupes/[bookquotationToken]/proforma": [101,[9,20,21]],
		"/backoffice/mon-restaurant/clients": [102,[9]],
		"/backoffice/mon-restaurant/configuration-livraison-emporter": [~103,[9]],
		"/backoffice/mon-restaurant/configuration-messages": [104,[9,22]],
		"/backoffice/mon-restaurant/generateur-de-carte": [105,[9,23]],
		"/backoffice/mon-restaurant/generateur-de-carte/relecture": [106,[9,23]],
		"/backoffice/mon-restaurant/ma-carte": [107,[9,24]],
		"/backoffice/mon-restaurant/ma-carte/forms/[type=formtypes]/[token]": [109,[9,24]],
		"/backoffice/mon-restaurant/ma-carte/[type]/[token]": [108,[9,24]],
		"/backoffice/mon-restaurant/ma-fiche": [110,[9]],
		"/backoffice/mon-restaurant/mes-candidatures": [111,[9]],
		"/backoffice/mon-restaurant/mes-horaires": [112,[9,25]],
		"/backoffice/mon-restaurant/mes-horaires/[for=schedule]": [~113,[9,25]],
		"/backoffice/mon-restaurant/mes-qrcodes": [114,[9,26]],
		"/backoffice/mon-restaurant/mes-sms": [115,[9]],
		"/backoffice/mon-restaurant/mon-equipe": [~116,[9]],
		"/backoffice/new-mobile": [~117,[9]],
		"/backoffice/nous-contacter": [118,[9,27]],
		"/backoffice/rapports/mes-avis": [~119,[9]],
		"/backoffice/rapports/statistique": [120,[9]],
		"/backoffice/telephone": [~121,[9]],
		"/collecte-info-restaurant": [~122,[28]],
		"/collecte-photos": [~123],
		"/email-preview/[token]": [~124],
		"/hub-after-sales": [~125],
		"/hub-after-sales/[tokenRestaurant]": [~126,[29]],
		"/hub-after-sales/[tokenRestaurant]/assistance": [127,[29]],
		"/hub-after-sales/[tokenRestaurant]/photos": [128,[29]],
		"/hub-after-sales/[tokenRestaurant]/resume": [129,[29]],
		"/hub-after-sales/[tokenRestaurant]/texts": [~130,[29,30]],
		"/hub-after-sales/[tokenRestaurant]/texts/generate": [131,[29,30]],
		"/hub-after-sales/[tokenRestaurant]/texts/read": [132,[29,30]],
		"/hub-after-sales/[tokenRestaurant]/texts/result": [133,[29,30]],
		"/livraison-emporter": [134,[31]],
		"/livraison-emporter/mobile/pages/dish/[dishId]": [135,[31,32]],
		"/livraison-emporter/mobile/pages/formule/[formulaToken]": [136,[31,32,33]],
		"/ma-demande-de-groupe/redirect/[bookNumber]": [138,[34]],
		"/ma-demande-de-groupe/[restaurantToken]/[bookQuotationToken]": [~137,[34]],
		"/no-show/[token]": [139],
		"/reservation-de-groupe": [150,[37]],
		"/reservation-de-groupe/confirm": [155,[37]],
		"/reservation-de-groupe/(steps)/date": [151,[37,38]],
		"/reservation-de-groupe/(steps)/hours": [152,[37,38]],
		"/reservation-de-groupe/(steps)/more-info": [153,[37,38]],
		"/reservation-de-groupe/(steps)/party-size": [154,[37,38]],
		"/reservation": [~140,[35]],
		"/reservation/(steps)/bank-footprint": [~144,[35,36]],
		"/reservation/(exceptional)/confirm": [~141,[35]],
		"/reservation/(steps)/date": [~145,[35,36]],
		"/reservation/(steps)/form": [~146,[35,36]],
		"/reservation/(exceptional)/franchise": [~142,[35]],
		"/reservation/(steps)/group-form": [~147,[35,36]],
		"/reservation/(steps)/hours": [~148,[35,36]],
		"/reservation/(steps)/party-size": [~149,[35,36]],
		"/reservation/(exceptional)/unique-menu": [143,[35]],
		"/signup/no-access": [~158,[39]],
		"/signup/[bkrToken]": [~156,[39,40]],
		"/signup/[bkrToken]/form": [~157,[39,40]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';